import { createSceneReducer } from '../../reducers-util';
import projectLocationsDataReducer from './project-locations.data';
import projectLocationsUiReducer from './project-locations.ui';

export default createSceneReducer(
  projectLocationsDataReducer,
  projectLocationsUiReducer
);
